import { dehydrate, QueryClient, useQuery } from 'react-query'
import { getCareers, getLegalDocs } from 'src/@shared/service/cms-api'
import { Jobs } from 'src/@shared/types/cms/jobs'
import CareersPage from '@modules/careers/components/CareerPage/CareerPage'
import { useEffect } from 'react'
import { scrollObjFromAnchor, scrollToTargetAdjusted } from 'src/@shared/functions/animations'
import { useRouter } from 'next/router'
import defaultSplashCard from '@assets/img/default-splash-card.png'

import { CMSList } from '../../@shared/types/cms/cms-list'
import { OpenGraphProps } from '../../@shared/components/head/customHead/customHead'

export async function getServerSideProps() {
    const queryClient = new QueryClient()
    // prefetch data on the server
    await Promise.all([
        queryClient.fetchQuery(['legaldocs'], () => getLegalDocs({ sort: 'position', limit: 0, page: 1 })),
        queryClient.fetchQuery(['careers'], () => getCareers()),
    ])
    return {
        props: {
            // dehydrate query cache
            dehydratedState: dehydrate(queryClient),
        },
    }
}

export default function Careers() {
    const { data } = useQuery(['careers'], () => getCareers())
    const jobs = (data as CMSList<Jobs>).data

    const title = 'Careers, Culture & Job Opportunities | Casper Labs'
    const description = `Join the dynamic team at Casper Labs and help us write blockchain's next chapter. Explore our job opportunities and apply today.`
    const og: OpenGraphProps = {
        ogTitle: title,
        ogDescription: description,
        ogImage: defaultSplashCard.src,
    }
    const defaultActiveKey = jobs && jobs.length > 0 ? jobs[0]._id : ''

    const router = useRouter()

    useEffect(() => {
        const timer = setTimeout(() => {
            scrollObjFromAnchor(router.asPath, 90)
            if (router.query.section) {
                scrollToTargetAdjusted(router.query.section.toString(), 90)
            }
        }, 1500)
        return () => {
            clearTimeout(timer)
        }
    }, [])

    return (
        <CareersPage jobs={jobs} defaultActiveKey={defaultActiveKey} title={title} description={description} og={og} />
    )
}
